import React from 'react';
import { useT } from '../i18n';

const HERMES_ORIGIN = 'https://hermes3000.ai';

export default function LegalFooter() {
  const t = useT();

  return (
    <footer className="py-4 px-4 text-center text-xs text-stone-400 font-sans shrink-0">
      <a
        href={`${HERMES_ORIGIN}/imprint`}
        target="_blank"
        rel="noopener noreferrer"
        className="underline hover:text-stone-600 transition-colors"
      >
        {t('legal.imprint')}
      </a>
      <span className="mx-2 opacity-50" aria-hidden>
        ·
      </span>
      <a
        href={`${HERMES_ORIGIN}/privacy`}
        target="_blank"
        rel="noopener noreferrer"
        className="underline hover:text-stone-600 transition-colors"
      >
        {t('legal.privacy')}
      </a>
    </footer>
  );
}
